var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8368 17.6567C40.8719 10.7567 36.4719 7 33.5 7C30.5281 7 26.1281 10.7567 25.1632 17.6567C24.2369 24.5567 27.286 30 33.5 30C39.714 30 42.7631 24.5567 41.8368 17.6567Z",
    fill: "#003E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1418 36.7117L17.7434 32.5609C12.4744 34.3361 9.54869 37.1156 8.10823 41.5474C7.46474 36.1293 8.70402 30.098 15.7321 26.5907L14.372 22.5536L24.335 27.0691L19.1418 36.7117Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveEgg);
export default __webpack_public_path__ + "static/media/remove_egg.d2dd7035357f3f76c5e0a8947fcfdaf0.svg";
export { ForwardRef as ReactComponent };